import React from "react";
import { useTable, usePagination } from "react-table";
import {
  Link
} from "react-router-dom";
import "./reactTable.css";
import DeleteIcon from "@material-ui/icons/Delete";
import DetailsIcon from "@material-ui/icons/Details";
import Tooltip from "@material-ui/core/Tooltip";
import GetAppIcon from "@material-ui/icons/GetApp";
import FindReplaceIcon from "@material-ui/icons/FindReplace";
import { Document, Page, pdfjs } from "react-pdf";
import { withStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";
import { Box, Grid, FormControlLabel, Checkbox } from "@material-ui/core";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const defaultPropGetter = () => ({});
const defaultPropGetterCells = () => ({});

function Table({
  linkColumns,
  replaceFunction,
  detailsFunction,
  deleteFunction,
  checkBoxFunction,
  columns,
  data,
  filters,
  fetchData,
  loading,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetterCells,
}) {
  //Window resize state variables for images in a table
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  });
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination
  );

  const RedCheckBox = withStyles({
    root: {
      color: red[400],
      '&$checked': {
        color: red[400],
      },
    },
    checked: {},
  })((props) => <Checkbox color="primary" {...props} />);

  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  if (cell.column.id === "details") {
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Tooltip disableFocusListener title="Open Details">
                          <button>
                            <DetailsIcon
                              onClick={() => detailsFunction(row.index)}
                            />
                          </button>
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "delete") {
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Tooltip disableFocusListener title="Delete">
                          <button>
                            <DeleteIcon
                              onClick={() => deleteFunction(row.index)}
                            />
                          </button>
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "replace") {
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Tooltip disableFocusListener title="Replace">
                          <button>
                            <FindReplaceIcon
                              onClick={() => replaceFunction(row.index)}
                            />
                          </button>
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "download") {
                    const data = cell.row.allCells[0].value;
                    const DownloadLink = ({ data }) => (
                      <a download href={require("../" + data)}>
                        <Tooltip disableFocusListener title="Download">
                          <button>
                            <GetAppIcon />
                          </button>
                        </Tooltip>
                      </a>
                    );
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <DownloadLink data={data} />
                      </td>
                    );
                  } else if (cell.column.id === "msa_file") {
                    const data = cell.value;
                    const Img = (
                      { data } //<embed type="application/pdf" src={`data:application/pdf;base64,${data}`}/>
                    ) => (
                      <>{data === ''?<></>:
                      <Document file={require("../"+data)}>
                        <Page
                          pageNumber={1}
                          width={dimensions.width > 960 ? 250 : 80}
                          height={dimensions.width > 960 ? 250 : 80}
                        />
                      </Document>}
                      </>
                    );

                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Img data={data} />
                      </td>
                    );
                  } else if (cell.column.id === "checkbox")
                  {
                    if (cell.row.original.isStandAlone){//Specifically for the standAloneCO checkbox due to the unique hovering text
                      return (
                        <td
                          onClick={(e) => e.stopPropagation()}
                          key={cell.column.id}
                        >
                          <Tooltip disableFocusListener title="Stand Alone?">
                            <FormControlLabel
                              disabled={false}
                              control={
                              <RedCheckBox
                                onChange={() => checkBoxFunction(row.index)}
                                checked={cell.row.original.isStandAlone}
                              />
                              }
                            />
                          </Tooltip>
                        </td>
                      );
                    } 
                    
                    if (cell.row.original.checkbox !== null) {//Generic checkbox implementation in the table
                      return (
                        <td
                          onClick={(e) => e.stopPropagation()}
                          key={cell.column.id}
                        >
                          <Tooltip disableFocusListener>
                            <FormControlLabel
                              disabled={false}
                              control={
                              <RedCheckBox
                                onChange={() => checkBoxFunction(row.index)}
                                checked={cell.row.original.checkbox}
                              />
                              }
                            />
                          </Tooltip>
                        </td>
                      );
                    }
                  } else {
                    if (linkColumns){
                      if (linkColumns.map(column => column.Header).includes(cell.column.Header)){
                        return (
                          <td {...cell.getCellProps(getCellProps(cell))}>
                            <Link to={{pathname: linkColumns.filter(col => col.Header===cell.column.Header)[0].path, state:{ ...cell.row.original, ...(linkColumns.filter(col => col.Header===cell.column.Header)[0].props)}}}>
                              {cell.render("Cell")}
                            </Link>
                          </td>
                        );
                      } else {
                        return (
                          <td {...cell.getCellProps(getCellProps(cell))}>{cell.render("Cell")}</td>
                        );
                      }
                    } else {
                      return (
                        <td {...cell.getCellProps(getCellProps(cell))}>{cell.render("Cell")}</td>
                      );
                    }
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* 
          Pagination can be built however you'd like. 
          This is just a very basic UI implementation:
        */}
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>{" "}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>{" "}
        <span className="paginationText">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <span className="paginationText">
          | Go to page:{" "}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "100px" }}
          />
        </span>{" "}
        <select
          className="paginationText"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
export default Table;
